module.exports = __webpack_public_path__ + "img/switch-values.fb118b75.svg";